module.exports = __webpack_public_path__ + "front/img/kv.03c73e59.jpg";